import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './PricedEmployeesChart.scss';

class PricedEmployeesChart extends Component {
  static propTypes = {
    pricedEmployees: PropTypes.number
  };

  render() {
    const strokeDashCount = 505;
    let pricedEmployees = this.props.pricedEmployees;
    if (!this.props.pricedEmployees) {
      pricedEmployees = 0;
    }
    const circleStyle = {
      strokeDashoffset: strokeDashCount - strokeDashCount * (pricedEmployees / 100),
      strokeDasharray: strokeDashCount
    };
    return (
      <div className="priced__chart">
        <div className="priced__chart--container">
          <svg className="priced__chart--outer">
            <circle cx="100" cy="90" r="80" style={circleStyle} transform="rotate(-90, 95, 95)" />
          </svg>
          <div className="priced__chart--center">
            <div className="priced__chart--title" data-testid="pricedEmployeesCount">
              {pricedEmployees}%
            </div>
            <div className="priced__chart--subtitle">Employees in Priced and Slotted Jobs</div>
          </div>
        </div>
      </div>
    );
  }
}

export default PricedEmployeesChart;
